//Custom components
import StatCard from '../../../UI/Card/StatCard';

const TotalClientsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Clients' stat={count} />;
};

export default TotalClientsWidget;
